export default {
  serviceCategory(state) {
    return state.serviceCategory
  },
  serviceCategories(state) {
    return state.serviceCategories
  },
  serviceWithWorkplaces(state) {
    return state.serviceWithWorkplaces
  },
  serviceCategoryFilters(state) {
    return state.serviceCategoryFilters
  },
  serviceCategoryErrors(state) {
    return state.serviceCategoryErrors
  },
  serviceCategoriesWithoutGroups(state) {
    return state.serviceWithoutGroups
  },
  shortServiceCategories(state) {
    return state.shortServiceCategories
  },
}
